import { useEffect } from "react";
import CustomButton from "../components/CustomButton";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import headShark from "../assets/new-ui/gameplay/gameplay-icon.png";
import circleShark from "../assets/new-ui/about-holysharks/circle-shark.png";
import gameplayCharacter from "../assets/new-ui/about-holysharks/Apollo.gif";
import decor from "../assets/new-ui/about-holysharks/decor.png";
import { FAQFirst, FAQSecond } from "../constants/FAQ";
import FAQElement from "../components/FAQElement";
import { useHistory } from "react-router-dom";
import ConnectWallet from "../components/ConnectWallet";
import CoralRightType2 from "../components/coral/CoralRightType2";
import Bubble from "../components/coral/Bubble";
export default function AboutHolysharks() {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pageContainer aboutHolySharksContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <CoralRightType2 />
      <Bubble top={"200px"} />
      <div className="content">
        <div className="pageTitle">ABOUT SHARKTOPIA</div>
        <div className="header">
          <img
            src={gameplayCharacter}
            alt="character"
            className="headerCharacter"
          />
          <div className="headerRight">
            <div className="headerRightBoxSmall">
              <div className="boxTitle">About NFTs</div>
              <div className="boxDescription">What exactly are Sharktopia?</div>
              <CustomButton
                text={"VIEW DETAIL"}
                textColor={"black"}
                fn={() => history.push("genesis-mystery-box")}
                type={"small"}
                transparent={false}
              />
              <img src={decor} alt="decor" />
            </div>
            <div className="headerRightBoxLarge">
              <div className="boxTitle">About The Metaverse Game</div>
              <div className="boxDescription">
                View the top 5 reasons to play Sharktopia Game.
              </div>
              <CustomButton
                text={"VIEW DETAIL"}
                textColor={"black"}
                fn={() => history.push("/metaverse-game-play")}
                type={"small"}
                transparent={false}
              />
            </div>
          </div>
        </div>
        <div className="FAQ">
          <div className="FAQTitle">FREQUENTLY ASKED QUESTIONS</div>
          <div className="FAQPart">
            <div className="FAQPartTitle">
              <img src={headShark} alt="head shark" />
              <div className="FAQTitleText">
                <div>SHARKTOPIA FAQ</div>
                <div>Q&A for Sharktopia</div>
              </div>
            </div>
            <div className="FAQList">
              {FAQFirst.map((item, index) => {
                return (
                  <FAQElement
                    question={item.question}
                    answer={item.answer}
                    key={index}
                  />
                );
              })}
            </div>
          </div>

          <div className="FAQPart">
            <div className="FAQPartTitle">
              <img src={circleShark} alt="circle shark" />
              <div className="FAQTitleText">
                <div>SHARKTOPIA TACTICS FAQ</div>
                <div>Q&A for Sharktopia Tactics</div>
              </div>
            </div>
            <div className="FAQList">
              {FAQSecond.map((item, index) => {
                return (
                  <FAQElement
                    question={item.question}
                    answer={item.answer}
                    key={index}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
